import { createContext, useContext } from "react"

const Budget2023Context = createContext({})

export const useBudget2023Context = () => useContext(Budget2023Context)

export default Budget2023Context
